import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {allpayments} from "models/allpayments"; // Importing allpayments model
import {devConfig, profile} from "config/config"; // Importing configuration settings

/**
 * Class representing the tableComissionsView.
 * @extends JetView
 */
export default class tableComissionsView extends JetView {
	/**
	 * Configures the view layout and components.
	 * @returns {Object} The configuration object for the view.
	 */
	config(){
		const _ = this.app.getService("locale")._; // Localization service
		const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
		const cur_user = this.getParam("user", true); // Current user parameter
		const accordion_section = {
			id: "b5", // ID for the accordion section
			rows: [] // Rows to be populated later
		};
		const table = {
			view:"datatable", // DataTable view
			css: "webix_header_border webix_data_border", // CSS classes for styling
			id: "datatable", // ID for the DataTable
			select:true, // Enable row selection
			columns:[
				{ id:"rating",	header:"",width:50, height: 25, tooltip:_("Editar"), // Column for editing
					template:function(obj){ // Template function for rendering edit icon
						if (devConfig.getPermAction("betShopComissionsEdit", "Edit")) {
							return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon
						} else {
							return ""; // No icon if no permission
						}
					}
				},
				{ id:"Id", header:"Id", width:200, sort:"int",hidden:true}, // Hidden ID column
				{ id:"ProductName", header:_("Producto"), width:250, sort:"int" }, // Product name column
				{ id:"ComissionLevelBetShop", header:_("Comisión Usuario"), width:130, sort:"int"}, // User commission column
				{ id:"ComissionLevel1", header:_("Por Concesionario"), width:130, sort:"int"}, // Commission level 1 column
				{ id:"ComissionLevel2", header:_("Por Subconcesionario"), width:130, sort:"int"}, // Commission level 2 column
				{ id:"ComissionLevel3", header:_("Por Subconcesionario 1"), width:130, sort:"int"}, // Commission level 3 column
				{ id:"ComissionLevel4", header:_("Por Subconcesionario 2"), width:130, sort:"int"}, // Commission level 4 column
				{ id:"Total", header:_("Total"), width:130, sort:"int"} // Total commission column
			],
			scheme:{
				$change: function calck_c(obj){ // Function to calculate total commission
					obj.Total = obj.ComissionLevelBetShop*1 + obj.ComissionLevel1*1 + obj.ComissionLevel2*1 + obj.ComissionLevel3*1 + obj.ComissionLevel4*1; // Total calculation
				}
			},
			tooltip:true, // Enable tooltips
			math: true, // Enable math operations
			onClick:	{
				"edit":function(euv, id){ // Event handler for edit button click
					$$("editwinComissions").show(); // Show edit window
				}
			}
		}
		return {
			view: "form", // Form view
			scroll:"y", // Enable vertical scrolling
			rows: [
				accordion_section, // Add accordion section
				table // Add data table
			]
		};
	}

	/**
	 * Initializes the view and loads data.
	 * @param {Object} grid - The grid component to attach events to.
	 */
	init(grid){
		const _ = this.app.getService("locale")._; // Localization service
		$$("datatable").hide(); // Hide the data table initially
		const cur_user = this.getParam("user", true); // Current user parameter
		var url = devConfig.geturlApi() + "es/BetShop/GetAgentComissionItems?FromId=" + cur_user + "&"; // API URL for fetching commission items
		$$("datatable").load(url + '?start=0&count=100').then(function(data){ // Load data into the table
			data = data.json(); // Parse JSON data
			data.Data.forEach(commision => { // Iterate over each commission item
				var maxComissionLevelBetShop; // Maximum commission level for BetShop
				var maxComissionLevel1; // Maximum commission level 1
				var maxComissionLevel2; // Maximum commission level 2
				var maxComissionLevel3; // Maximum commission level 3
				var maxComissionLevel4; // Maximum commission level 4
				var hiddenComissionLevelBetShop = false; // Flag for hiding BetShop commission level
				var hiddenComissionLevel1 = false; // Flag for hiding commission level 1
				var hiddenComissionLevel2 = false; // Flag for hiding commission level 2
				var hiddenComissionLevel3 = false; // Flag for hiding commission level 3
				var hiddenComissionLevel4 = false; // Flag for hiding commission level 4
				var total = 0; // Total commission variable
				if(commision.ComissionLevelBetShop == undefined){ // Check if BetShop commission is defined
					hiddenComissionLevelBetShop = true; // Set flag to hide
				}else{
					total = total + commision.ComissionLevelBetShop*1; // Add to total
				}
				if(commision.ComissionLevel1 == undefined){ // Check if commission level 1 is defined
					hiddenComissionLevel1 = true; // Set flag to hide
				}else{
					total = total + commision.ComissionLevel1*1; // Add to total
				}
				if(commision.ComissionLevel2 == undefined){ // Check if commission level 2 is defined
					hiddenComissionLevel2 = true; // Set flag to hide
				}else{
					total = total + commision.ComissionLevel2*1; // Add to total
				}
				if(commision.ComissionLevel3 == undefined){ // Check if commission level 3 is defined
					hiddenComissionLevel3 = true; // Set flag to hide
				}else{
					total = total + commision.ComissionLevel3*1; // Add to total
				}
				if(commision.ComissionLevel4 == undefined){ // Check if commission level 4 is defined
					hiddenComissionLevel4 = true; // Set flag to hide
				}else{
					total = total + commision.ComissionLevel4*1; // Add to total
				}
				commision.Total = total; // Set total commission
				$$("b5").addView({ // Add new accordion view for each commission
					multi: true, // Allow multiple open sections
					view: "accordion", // Accordion view
					css: "betShop", // CSS class for styling
					collapsed: true, // Start collapsed
					paddingY: 10, // Vertical padding
					type: "clean", // Clean type
					id:"a1", // ID for the accordion
					rows: [{
						responsive:"a1", // Responsive design
						header: commision.ProductName, body: { // Header with product name
							view: "form", id: commision.Id, // Form view for commission details
							padding: 10, height:(screen.width > 500) ? 0 : 450, // Dynamic height based on screen width
							css: "on-row", // CSS class for styling
							elements: [
								{
									margin: 5, // Margin for the element
									minWidth: 250, // Minimum width
									css: "on-row", // CSS class for styling
									rows: [
										{
											margin: 10, // Margin for the element
											css: "on-row", // CSS class for styling
											cols: [
												{view: "text", label: "Id", name: "Id", readonly: true, hidden:true}, // Hidden ID field
												{view: "text", label: _("Producto"), name: "ProductName", readonly: true, hidden:true}, // Hidden product name field
												{view: "text", label: _("Comisión Usuario"), labelPosition: "top", name: "ComissionLevelBetShop", readonly: false, type:"number", required: true, minWidth:250, hidden:hiddenComissionLevelBetShop}, // User commission field
												{view: "text", label: _("Por Concesionario"), labelPosition: "top", name: "ComissionLevel1", readonly: false, type:"number", required: true, minWidth:250, hidden:hiddenComissionLevel1}, // Commission level 1 field
												{view: "text", label: _("Por Subconcesionario"), labelPosition: "top", name: "ComissionLevel2", readonly: false, type:"number", required: true, minWidth:250, hidden:hiddenComissionLevel2}, // Commission level 2 field
												{view: "text", label: _("Por Subconcesionario 1"), labelPosition: "top", name: "ComissionLevel3", readonly: false, type:"number", required: true, minWidth:250, hidden:hiddenComissionLevel3} // Commission level 3 field
											]
										},
										{
											margin: 10, // Margin for the element
											css: "on-row", // CSS class for styling
											cols: [
												{view: "text", label: _("Por Subconcesionario 2"), labelPosition: "top", name: "ComissionLevel4", readonly: false, type:"number", required: true, minWidth:250, hidden: hiddenComissionLevel4}, // Commission level 4 field
												{view: "text", label: _("Total"), id:"Total"+commision.Id, labelPosition: "top", name: "Total", readonly: true, disabled:true, type:"number", minWidth:250}, // Total commission field
											]
										},
										{
											view: "button", type: "form", value: _("Guardar"), hidden: !devConfig.getPermAction("betShopComissionsEdit", "Edit"), css:"prm-betShopComissionsEdit", click: function () { // Save button
												var values = $$(commision.Id).getValues(); // Get form values
												if(hiddenComissionLevelBetShop){ // Check if BetShop commission is hidden
													delete values.ComissionLevelBetShop; // Remove from values
												}
												if(hiddenComissionLevel1){ // Check if commission level 1 is hidden
													delete values.ComissionLevel1; // Remove from values
												}
												if(hiddenComissionLevel2){ // Check if commission level 2 is hidden
													delete values.ComissionLevel2; // Remove from values
												}
												if(hiddenComissionLevel3){ // Check if commission level 3 is hidden
													delete values.ComissionLevel3; // Remove from values
												}
												if(hiddenComissionLevel4){ // Check if commission level 4 is hidden
													delete values.ComissionLevel4; // Remove from values
												}
												values.FromId = cur_user; // Add current user to values
												if ($$(commision.Id).validate() && ((values.SumMaxComission != undefined && values.SumMaxComission != null && values.SumMaxComission * 1 != 0 && values.SumMaxComission != '') && values.Total * 1 <= values.SumMaxComission * 1)) { // Validate form and check total against max commission
													webix.ajax().headers({
														"Content-type": "application/json" // Set content type for AJAX request
													}).post(devConfig.geturlApi() + "BetShop/SaveComissions", values, { // Send POST request to save commissions
														error: function (text, data, XmlHttpRequest) {
															webix.message(_("Error! ")); // Show error message
														},
														success: function (text, data, XmlHttpRequest) {
															var data = JSON.parse(text); // Parse response data
															if(data.HasError){ // Check for errors in response
																webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Show error message
															}else{
																webix.message(_("Valores Editados")); // Show success message
																grid.clearAll(); // Clear grid data
																grid.load(url); // Reload grid data
															}
														}
													});
												}else{
													if(!$$(commision.Id).validate()){ // Validate form
														webix.message({
															title: _("¡Error!"),
															type: "alert-error",
															text: _("Valores no permitiros...") // Show validation error message
														});
													}else{
														webix.message({
															title: _("¡Error!"),
															type: "alert-error",
															text: _("Total supera el máximo permitido...") // Show total exceeded error message
														});
													}
												}
											}
										}
									]
								}
							], elementsConfig: {
								on: {
									onChange: function () {
										this.validate(); // Validate form on change
									}
								}
							},
							on:{
								onChange(){ // Event handler for changes in form
									var values = $$(commision.Id).getValues(); // Get form values
									var total = 0; // Initialize total
									if(values.ComissionLevelBetShop != undefined){ // Check if BetShop commission is defined
										total = total + values.ComissionLevelBetShop * 1; // Add to total
									}
									if(values.ComissionLevel1 != undefined){ // Check if commission level 1 is defined
										total = total + values.ComissionLevel1 * 1; // Add to total
									}
									if(values.ComissionLevel2 != undefined){ // Check if commission level 2 is defined
										total = total + values.ComissionLevel2 * 1; // Add to total
									}
									if(values.ComissionLevel3 != undefined){ // Check if commission level 3 is defined
										total = total + values.ComissionLevel3 * 1; // Add to total
									}
									if(values.ComissionLevel4 != undefined){ // Check if commission level 4 is defined
										total = total + values.ComissionLevel4 * 1; // Add to total
									}
									values.Total = total; // Set total commission
									$$("Total" + commision.Id).setValue(values.Total); // Update total field in form
								}
							},
							rules: { // Validation rules for form fields
								MaxComissionLevelBetShop: function (value) {
									if(value != undefined && value != null && value * 1 != 0 && value != ''){
										maxComissionLevelBetShop = value; // Set max commission level for BetShop
									}
									return true; // Always return true for validation
								},
								MaxComissionLevel1: function (value) {
									if(value != undefined && value != null && value * 1 != 0 && value != ''){
										maxComissionLevel1 = value; // Set max commission level 1
									}
									return true; // Always return true for validation
								},
								MaxComissionLevel2: function (value) {
									if(value != undefined && value != null && value * 1 != 0 && value != ''){
										maxComissionLevel2 = value; // Set max commission level 2
									}
									return true; // Always return true for validation
								},
								MaxComissionLevel3: function (value) {
									if(value != undefined && value != null && value * 1 != 0 && value != ''){
										maxComissionLevel3 = value; // Set max commission level 3
									}
									return true; // Always return true for validation
								},
								MaxComissionLevel4: function (value) {
									if(value != undefined && value != null && value * 1 != 0 && value != ''){
										maxComissionLevel4 = value; // Set max commission level 4
									}
									return true; // Always return true for validation
								},
								ComissionLevelBetShop: function (value) {
									if(maxComissionLevelBetShop != undefined){ // Check if max commission level for BetShop is defined
										return value * 1 >= 0 && value * 1 <= maxComissionLevelBetShop * 1; // Validate against max
									}else{
										return value * 1 >= 0; // Validate non-negative
									}
								},
								ComissionLevel1: function (value) {
									if(maxComissionLevel1 != undefined){ // Check if max commission level 1 is defined
										return value * 1 >= 0 && value * 1 <= maxComissionLevel1 * 1; // Validate against max
									}else{
										return value * 1 >= 0; // Validate non-negative
									}
								},
								ComissionLevel2: function (value) {
									if(maxComissionLevel2 != undefined){ // Check if max commission level 2 is defined
										return value * 1 >= 0 && value * 1 <= maxComissionLevel2 * 1; // Validate against max
									}else{
										return value * 1 >= 0; // Validate non-negative
									}
								},
								ComissionLevel3: function (value) {
									if(maxComissionLevel3 != undefined){ // Check if max commission level 3 is defined
										return value * 1 >= 0 && value * 1 <= maxComissionLevel3 * 1; // Validate against max
									}else{
										return value * 1 >= 0; // Validate non-negative
									}
								},
								ComissionLevel4: function (value) {
									if(maxComissionLevel4 != undefined){ // Check if max commission level 4 is defined
										return value * 1 >= 0 && value * 1 <= maxComissionLevel4 * 1; // Validate against max
									}else{
										return value * 1 >= 0; // Validate non-negative
									}
								}
							}
						}
					}]
				})
				$$(commision.Id).setValues(commision); // Set initial values for the form
			})
		});
		grid.attachEvent("onAfterSort", function(by, dir, as){ // Event handler for sorting
			grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&sort[' + by + ']=' + dir ); // Reload data with sorting
		});
		grid.attachEvent("onItemClick", function(id, e, node){ // Event handler for item click
			var item = this.getItem(id); // Get clicked item
			this.$scope.app.callEvent("user:id",[item.Id]); // Call event with user ID
		});
		var maxComissionLevelBetShop; // Maximum commission level for BetShop
		var maxComissionLevel1; // Maximum commission level 1
		var maxComissionLevel2; // Maximum commission level 2
		var maxComissionLevel3; // Maximum commission level 3
		var maxComissionLevel4; // Maximum commission level 4
		var popup = webix.ui({ // Create edit window
			view: "window", // Window view
			id: "editwinComissions", // ID for the window
			head: {
				view:"toolbar", // Toolbar for window header
				cols:[
					{view:"label", label:_("Editar Comisión")}, // Label for editing commission
					{view:"icon", icon:"wxi-close", click:function(){ // Close button
							this.getTopParentView().hide(); // Hide window
						}}
				]
			},
			position: "center", // Center the window
			modal: true, // Make window modal
			body: {
				view: "form", id: "editformComissions", // Form view for editing commissions
				elements: [
					{view: "text", label: "Id", labelWidth:150, name: "Id", readonly: true, hidden:true}, // Hidden ID field
					{view: "text", label: _("Producto"), labelWidth:150, name: "ProductName", readonly: true}, // Product name field
					{view: "text", label: _("Comisión Usuario"), labelWidth:150, name: "ComissionLevelBetShop", readonly: false, type:"number", required: true}, // User commission field
					{view: "text", label: _("Por Concesionario"), labelWidth:150, name: "ComissionLevel1", readonly: false, type:"number", required: true}, // Commission level 1 field
					{view: "text", label: _("Por Subconcesionario"), labelWidth:150, name: "ComissionLevel2", readonly: false, type:"number", required: true}, // Commission level 2 field
					{view: "text", label: _("Por Subconcesionario 1"), labelWidth:150, name: "ComissionLevel3", readonly: false, type:"number", required: true}, // Commission level 3 field
					{view: "text", label: _("Por Subconcesionario 2"), labelWidth:150, name: "ComissionLevel4", readonly: false, type:"number", required: true}, // Commission level 4 field
					{view: "text", id: "Total", label: _("Total"), labelWidth:150, name: "Total", readonly: true, disabled:true, type:"number"}, // Total commission field
					{
						cols: [
							{
								view: "button", value: _("Cancelar"), click: function () { // Cancel button
									this.getTopParentView().hide(); // Hide window
								}
							},
							{
								view: "button", type: "form", value: _("Guardar"), click: function ($e) { // Save button
									var values = $$("editformComissions").getValues(); // Get form values
									if ($$("editformComissions").validate() && ((values.SumMaxComission != undefined && values.SumMaxComission != null && values.SumMaxComission * 1 != 0 && values.SumMaxComission != '') && values.Total * 1 <= values.SumMaxComission * 1)) { // Validate form and check total against max commission
										webix.ajax().headers({
											"Content-type": "application/json" // Set content type for AJAX request
										}).post(devConfig.geturlApi() + "BetShop/SaveComissions", '{"FromId":"' + cur_user + '","Id":"' + values.Id + '","ProductName":"' + values.ProductName + '","ComissionLevel1":"' + values.ComissionLevel1 + '","ComissionLevel2":"' + values.ComissionLevel2 + '","ComissionLevel3":"' + values.ComissionLevel3 + '","ComissionLevel4":"' + values.ComissionLevel4 + '","ComissionLevelBetShop":"' + values.ComissionLevelBetShop + '"}', { // Send POST request to save commissions
											error: function (text, data, XmlHttpRequest) {
												webix.message(_("Error! ")); // Show error message
											},
											success: function (text, data, XmlHttpRequest) {
												var data = JSON.parse(text); // Parse response data
												if(data.HasError){ // Check for errors in response
													webix.message({title: _("¡Error!"), type:"alert-error", text: _("Ocurrio un error.")}); // Show error message
												}else{
													webix.message(_("Valores Editados")); // Show success message
													grid.clearAll(); // Clear grid data
													grid.load(url); // Reload grid data
												}
											}
										});
										this.getTopParentView().hide(); // Hide window after saving
									}else{
										if(!$$("editformComissions").validate()){ // Validate form
											webix.message({
												title: _("¡Error!"),
												type: "alert-error",
												text: _("Valores no permitiros...") // Show validation error message
											});
										}else{
											webix.message({
												title: _("¡Error!"),
												type: "alert-error",
												text: _("Total supera el máximo permitido...") // Show total exceeded error message
											});
										}
									}
								}
							}
						]
					}
				], elementsConfig: {
					on: {
						onChange: function () {
							this.validate(); // Validate form on change
						}
					}
				},
				on:{
					onChange(){ // Event handler for changes in form
						var values = $$("editformComissions").getValues(); // Get form values
						values.Total = values.ComissionLevelBetShop * 1 + values.ComissionLevel1 * 1 + values.ComissionLevel2 * 1 + values.ComissionLevel3 * 1 + values.ComissionLevel4 * 1; // Calculate total commission
						$$("Total").setValue(values.Total); // Update total field in form
					}
				},
				rules: { // Validation rules for form fields
					MaxComissionLevelBetShop: function (value) {
						if(value != undefined && value != null && value * 1 != 0 && value != ''){
							maxComissionLevelBetShop = value; // Set max commission level for BetShop
						}
						return true; // Always return true for validation
					},
					MaxComissionLevel1: function (value) {
						if(value != undefined && value != null && value * 1 != 0 && value != ''){
							maxComissionLevel1 = value; // Set max commission level 1
						}
						return true; // Always return true for validation
					},
					MaxComissionLevel2: function (value) {
						if(value != undefined && value != null && value * 1 != 0 && value != ''){
							maxComissionLevel2 = value; // Set max commission level 2
						}
						return true; // Always return true for validation
					},
					MaxComissionLevel3: function (value) {
						if(value != undefined && value != null && value * 1 != 0 && value != ''){
							maxComissionLevel3 = value; // Set max commission level 3
						}
						return true; // Always return true for validation
					},
					MaxComissionLevel4: function (value) {
						if(value != undefined && value != null && value * 1 != 0 && value != ''){
							maxComissionLevel4 = value; // Set max commission level 4
						}
						return true; // Always return true for validation
					},
					ComissionLevelBetShop: function (value) {
						if(maxComissionLevelBetShop != undefined){ // Check if max commission level for BetShop is defined
							return value * 1 >= 0 && value * 1 <= maxComissionLevelBetShop * 1; // Validate against max
						}else{
							return value * 1 >= 0; // Validate non-negative
						}
					},
					ComissionLevel1: function (value) {
						if(maxComissionLevel1 != undefined){ // Check if max commission level 1 is defined
							return value * 1 >= 0 && value * 1 <= maxComissionLevel1 * 1; // Validate against max
						}else{
							return value * 1 >= 0; // Validate non-negative
						}
					},
					ComissionLevel2: function (value) {
						if(maxComissionLevel2 != undefined){ // Check if max commission level 2 is defined
							return value * 1 >= 0 && value * 1 <= maxComissionLevel2 * 1; // Validate against max
						}else{
							return value * 1 >= 0; // Validate non-negative
						}
					},
					ComissionLevel3: function (value) {
						if(maxComissionLevel3 != undefined){ // Check if max commission level 3 is defined
							return value * 1 >= 0 && value * 1 <= maxComissionLevel3 * 1; // Validate against max
						}else{
							return value * 1 >= 0; // Validate non-negative
						}
					},
					ComissionLevel4: function (value) {
						if(maxComissionLevel4 != undefined){ // Check if max commission level 4 is defined
							return value * 1 >= 0 && value * 1 <= maxComissionLevel4 * 1; // Validate against max
						}else{
							return value * 1 >= 0; // Validate non-negative
						}
					}
				}
			}
		});
		this.on(this.app,"player:select",Id => { // Event handler for player selection
			grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + Id); // Load grid data based on selected player
		});
		grid.attachEvent("onItemDblClick", function (id, e, node) { // Event handler for double-click on item
			if(devConfig.getPermAction("permComissions", "Edit")){ // Check edit permission
				popup.show(); // Show edit window
			}
		});
		$$("editformComissions").bind($$("datatable")); // Bind edit form to data table
	}
}

// FILE DOCUMENTED
